// extracted by mini-css-extract-plugin
module.exports = {"pagination":"PaymentList_pagination__4dXTB"};